import { createActionFactory } from '../../../../../common/redux';
const { createAction } = createActionFactory('DeniedPanelApp => ');

const redirectRequest = createAction('denied redirect request');
const redirectRequestSuccess = createAction('denied redirect success');
const redirectRequestFailure = createAction('denied redirect failure');

export default {
  redirectRequest,
  redirectRequestSuccess,
  redirectRequestFailure,
};
